module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#facebook",
      toString: function () {
        return this.url;
      }
    }